export default __webpack_public_path__ + "static/media/link_logo.75fbe056.svg";